module.exports = __webpack_public_path__ + "img/gcc-brokers-cashier.2784f75f.webp";